import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { loadAvailableCategories } from './actions';

function CategoryLink({
  tag,
  url,
  name,
  availableCategories,
  loadAvailableCategories,
  onClick,
  children,
  className,
  style
}) {
  const categories = availableCategories || {};

  const categoryCount = Object.keys(categories).length;
  useEffect(() => {
    if (categoryCount === 0) loadAvailableCategories();
  }, [categoryCount, loadAvailableCategories]);

  const categoryData = categories[tag];
  if (!categoryData || !categoryData.product_count) return null;

  let category = { ...categoryData.category };
  if (name) category.name = name;

  let content = '';
  if (children) {
    content = typeof children === 'function' ? children(category) : children;
  } else if (category.name) {
    content = category.name;
  }

  return (
    <Link
      to={url || `/${category.url_name}`}
      onClick={onClick}
      className={className}
      style={style}
    >
      {content}
    </Link>
  );
}

const ConnectedCategoryLink = connect(
  state => ({
    availableCategories: state.availableCategories
  }),
  { loadAvailableCategories }
)(CategoryLink);

export default ConnectedCategoryLink;
